import Swal from 'sweetalert2';

import SiteServices from 'Services/SiteService';

const buildMessage = (siteLabel, entityLabel) =>
  `Commercial site "${siteLabel}" has got company attached. Do you want to create this ${entityLabel} without a company?`;

const resolveSite = async (site, siteId) => {
  if (site) {
    return site;
  }

  if (!siteId) {
    return null;
  }

  try {
    return await SiteServices.getSite(siteId);
  } catch (error) {
    return null;
  }
};

const isCommercialSite = (site) =>
  Boolean(site?.company_id || site?.company?.id);

const buildConfirmOptions = (siteLabel, entityLabel) => ({
  title: 'Company Missing',
  message: buildMessage(siteLabel, entityLabel),
  icon: 'warning',
  confirmText: 'Create Without Company',
  cancelText: 'Cancel',
  confirmButtonColor: '#3085d6',
  cancelButtonColor: '#d33',
});

export const confirmMissingCompany = async ({
  site,
  siteId,
  hasCompany,
  entityLabel,
  confirm,
}) => {
  if (hasCompany) {
    return { confirmed: true, forceWithoutCompany: false };
  }

  const resolvedSite = await resolveSite(site, siteId);
  if (!resolvedSite || !isCommercialSite(resolvedSite)) {
    return { confirmed: true, forceWithoutCompany: false };
  }

  const options = buildConfirmOptions(resolvedSite?.site_name, entityLabel);
  const confirmed = await confirm(options);

  return { confirmed, forceWithoutCompany: confirmed };
};

export const confirmMissingCompanyWithSwal = async ({
  site,
  siteId,
  hasCompany,
  entityLabel,
  swal = Swal,
}) =>
  confirmMissingCompany({
    site,
    siteId,
    hasCompany,
    entityLabel,
    confirm: async ({
      title,
      message,
      icon,
      confirmText,
      cancelText,
      confirmButtonColor,
      cancelButtonColor,
    }) => {
      const result = await swal.fire({
        title,
        text: message,
        icon,
        showCancelButton: true,
        confirmButtonColor,
        cancelButtonColor,
        confirmButtonText: confirmText,
        cancelButtonText: cancelText,
      });
      return Boolean(result?.isConfirmed);
    },
  });

export const confirmMissingCompanyWithNotification = async ({
  site,
  siteId,
  hasCompany,
  entityLabel,
  notification,
}) =>
  confirmMissingCompany({
    site,
    siteId,
    hasCompany,
    entityLabel,
    confirm: ({
      title,
      message,
      icon,
      confirmText,
      cancelText,
      confirmButtonColor,
      cancelButtonColor,
    }) =>
      notification.confirm({
        title,
        message,
        icon,
        confirmText,
        cancelText,
        confirmButtonColor,
        cancelButtonColor,
      }),
  });
